import type { Editor } from '../editor'

export function hasExtension(editor: Editor | undefined, name: string) {
  if (!editor) return false
  return editor.hasExtension(name)
}
